import { render, staticRenderFns } from "./DictInput2.vue?vue&type=template&id=a057835c&"
import script from "./DictInput2.vue?vue&type=script&lang=js&"
export * from "./DictInput2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports